export default __webpack_public_path__ + "static/media/item2.618bf136.jpg";